import { useEffect, useState } from 'react'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import classes from './tenis.module.css'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'

const Tenis = () => {
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      odds: ['', ''],
      sets: [''],
      setsBoth: ['', '', '', '', '', ''],
    },
    results: {
      oddsPercentages: ['', ''],
      sets: ['', '', '', ''],
      score: ['', ''],
      teamStrengths: ['', '', '', '', '', '', '', ''],
    },
  })

  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const clearFields = () => {
    setData({
      values: {
        odds: ['', ''],
        sets: [''],
        setsBoth: ['', '', '', '', '', ''],
      },
      results: {
        oddsPercentages: ['', ''],
        sets: ['', '', '', ''],
        score: ['', ''],
        teamStrengths: ['', '', '', '', '', '', '', ''],
      },
    })
    setShowInputArea(true)
  }

  const calculateStoniTenisStats = () => {
    const odds = data?.values?.odds || ['', '']
    const sets = data?.values?.sets || ['']
    const setsBoth = data?.values?.setsBoth || ['', '', '', '', '', '']

    const [odd1Str, odd2Str] = odds
    const [setsToWinStr] = sets
    const [wins1Str, losses1Str, played1Str, wins2Str, losses2Str, played2Str] =
      setsBoth

    const odd1 = parseFloat(odd1Str) || 0
    const odd2 = parseFloat(odd2Str) || 0
    const setsToWin = parseInt(setsToWinStr, 10) || 3

    const impliedProb1 = odd1 ? 1 / odd1 : 0
    const impliedProb2 = odd2 ? 1 / odd2 : 0

    const totalImplied = (impliedProb1 + impliedProb2) * 100
    const overround = totalImplied - 100
    const halfOverround = overround / 2

    const adjustedProb1 = impliedProb1 * 100 - halfOverround
    const adjustedProb2 = impliedProb2 * 100 - halfOverround

    const finalProb1 = adjustedProb1.toFixed(2)
    const finalProb2 = adjustedProb2.toFixed(2)

    const wins1 = parseInt(wins1Str, 10) || 0
    const losses1 = parseInt(losses1Str, 10) || 0
    const played1 = parseInt(played1Str, 10) || 0
    const wins2 = parseInt(wins2Str, 10) || 0
    const losses2 = parseInt(losses2Str, 10) || 0
    const played2 = parseInt(played2Str, 10) || 0

    const snd = played1 ? wins1 / played1 : 0
    const sod = played1 ? losses1 / played1 : 0
    const sog = played2 ? wins2 / played2 : 0
    const sng = played2 ? losses2 / played2 : 0

    const sndg = ((snd + sng) / 2).toFixed(2)
    const sodg = ((sod + sog) / 2).toFixed(2)
    const sndsog = ((snd + sog) / 2).toFixed(2)
    const sodsng = ((sod + sng) / 2).toFixed(2)

    let e60 = setsToWinStr * 2 - 1

    let g57 = sog + sng

    let f57 = snd + sod

    let f59 = (f57 + g57) / 2

    let f60 = e60 / 2

    let g59

    if (f59 > e60) {
      g59 = (parseFloat(setsToWinStr) + e60) / 2
    } else {
      g59 = f59
    }

    let aj60 = finalProb2

    let al60 = (aj60 * g59) / 100

    let ak60 = (finalProb1 * g59) / 100

    let ar60

    if (parseFloat(finalProb1) >= parseFloat(finalProb2)) {
      ar60 = Math.round(f60)
    } else {
      ar60 = ak60
    }

    let ao60 = Math.round(al60)

    // console.log(al60);

    let as60

    if (ar60 === Math.round(f60)) {
      as60 = ao60
    } else {
      as60 = Math.round(f60)
    }

    // console.log(ar60, as60);

    let at60 = parseFloat(ar60) + parseFloat(as60)

    let v59 = finalProb1

    let b60 = v59

    let au60

    let w59 = finalProb2

    let c60 = w59

    if (at60 >= e60 && b60 >= c60) {
      au60 = Math.round(f60)
    } else {
      au60 = ar60
    }

    const expectedSets1 = Math.round(au60)
    let av60

    // console.log(at60, e60, procenatPobede1, procenatPobede2);

    if (at60 >= e60 && parseFloat(finalProb1) < parseFloat(finalProb2)) {
      av60 = f60
    } else {
      av60 = as60
    }
    const expectedSets2 = Math.round(av60)
    let n35 = Math.round(au60)
    let r35 = Math.round(av60)

    let d62 = (n35 + r35) * 12

    let g70 = d62

    let aj70 = parseFloat(finalProb2) / 100

    let al70 = aj70 * g70

    let b58 = wins1

    let m69 = b58

    let o69 = 1 / m69

    let c58 = wins2

    let n69 = c58

    let p69 = 1 / n69

    let q69 = o69 + p69

    let r69 = q69 - 100

    let s69 = r69 / 2

    let t69 = o69 - s69

    let v69

    if (t69 < 0) {
      v69 = 0
    } else {
      v69 = t69
    }

    let ai70 = v69

    let ak70 = (finalProb1 * g70) / 100

    let am70 = ak70

    let ao70 = al70

    let f72

    if (am70 >= ao70) {
      f72 = ao70
    } else {
      f72 = am70
    }

    let j72

    if (n35 > r35) {
      j72 = n35 * 6
    } else {
      j72 = f72
    }

    let expectedGem1 = j72
    let l72

    if (r35 > n35) {
      l72 = r35 * 6
    } else {
      l72 = parseFloat(f72).toFixed(0)
    }

    let expectedGem2 = l72
    let expectedGemMatch = parseFloat(expectedGem1) + parseFloat(expectedGem2)

    const midSets = (expectedSets1 + expectedSets2) / 2

    let firstNum
    let secondNum

    if (expectedGem1 > expectedGem2) {
      firstNum = expectedGem1
      secondNum = expectedGem2
    } else {
      firstNum = expectedGem2
      secondNum = expectedGem1
    }

    let betkoPredlogValue = parseFloat(firstNum) - parseFloat(secondNum) / 2
    setData((prev) => ({
      ...prev,
      results: {
        oddsPercentages: [finalProb1, finalProb2],
        sets: [
          betkoPredlogValue.toFixed(2),
          expectedGemMatch.toFixed(0),
          expectedGem1.toFixed(0),
          expectedGem2,
        ],
        score: [expectedSets1, expectedSets2],
        teamStrengths: [
          snd.toFixed(2),
          sod.toFixed(2),
          sng.toFixed(2),
          sog.toFixed(2),
          sndg,
          sodg,
          sndsog,
          sodsng,
        ],
      },
    }))
  }

  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      return
    }
    setShowInputArea((prev) => !prev)
  }

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  console.log('data', data)

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={`Tenis`} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled}>
            {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
          </button>
        </div>
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Upiši kvote za ishod meča
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'odds'}
                labelPrefix={['KI 1', 'KI 2']}
                step={['0.1', '0.1']}
                min={['0.1', '0.1']}
                type={['number', 'number']}
                setError={setError}
                rows={2}
                calculation={calculateStoniTenisStats}
              />
              <div className={classesK.sectionTitle}>
                Meč na broj dobijenih setova
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'sets'}
                labelPrefix={['Br. dobijenih setova na koliko se igra meč']}
                step={['1']}
                min={['1']}
                type={['number']}
                setError={setError}
                rows={1}
                calculation={calculateStoniTenisStats}
              />
              <div className={classesK.sectionTitle}>
                Upiši br. Setova / br. ut. za oba tima
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'setsBoth'}
                labelPrefix={[
                  'TIM / IGRAČ 1 +  (pobedio setova)',
                  'TIM / IGRAČ 1 - (izgubio setova)',
                  'TIM / IGRAČ 1 (odigrao br. mečeva)',
                  'TIM / IGRAČ 2 +  (pobedio setova)',
                  'TIM / IGRAČ 2-  (izgubio setova)',
                  'TIM / IGRAČ 2 (odigrao br. mečeva)',
                ]}
                step={['1', '1', '1', '1', '1', '1']}
                min={['1', '1', '1', '1', '1', '1']}
                type={[
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                setError={setError}
                rows={3}
                calculation={calculateStoniTenisStats}
              />
            </div>
          </>
        )}

        {!showInputArea && (
          <div className={classes.sectionResults}>
            <ResultsSection
              title={'Ishod meča'}
              subtitle={'Konačan ishod'}
              results={data?.results?.oddsPercentages.map(
                (result) => `${result}%`
              )}
              names={['KI 1', 'KI 2']}
              withPercent={true}
            />
            <ResultsSection
              title={'Gemovi'}
              subtitle={'Predikcije gemova'}
              results={data?.results?.sets}
              names={[
                'Betko predlog za broj gemova na meču ( + )',
                'Predikcija srednjeg br. gemova na meču',
                'Predikcija - Broj gemova Tim / Igrač 1',
                'Predikcija - Broj gemova Tim / Igrač 2',
              ]}
              rows={2}
            />
            <ResultsSection
              title={'Tačan rezultat u setovima'}
              subtitle={'Predikcije osvojenih setova'}
              results={data?.results?.score}
              names={[
                'Očekivani broj osvojenih setova Tim/Igrač 1',
                'Očekivani broj osvojenih setova Tim/Igrač 2',
              ]}
            />
            <ResultsSection
              title={'Snage timova'}
              subtitle={'Snaga Tim / Igrač 1'}
              results={[
                data?.results?.teamStrengths[0],
                data.results?.teamStrengths[1],
              ]}
              names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snaga Tim / Igrač 2'}
              results={[
                data?.results?.teamStrengths[2],
                data.results?.teamStrengths[3],
              ]}
              names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snage oba Tima / igrača'}
              results={[
                data?.results?.teamStrengths[4],
                data.results?.teamStrengths[5],
              ]}
              names={[
                'SNDG ( snaga napada domaćina i gosta )',
                'SODG ( snaga odbrane domaćina i gosta )',
              ]}
            />
            <ResultsSection
              subtitle={'Tim / igrač proseci odbrana i napada'}
              results={[
                data?.results?.teamStrengths[6],
                data.results?.teamStrengths[7],
              ]}
              names={[
                'SND + SOG ( dom.daje/gost prima )',
                'SOD + SNG ( dom. prima/gost daje )',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default Tenis
